import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-solid-svg-icons'

import classNames from 'classnames'
import classes from './styles.module.scss'

interface IAvatarProps {
  name: string
  size?: 'small' | 'medium' | 'large'
  id?: string
  /** Draws the partial ring that marks the profile as missing something. */
  isIncomplete?: boolean
}

export const Avatar = (props: IAvatarProps) => {
  const { name = '', size = 'medium', id, isIncomplete = false } = props
  let trimmedName = name?.trim()

  const nameParts = trimmedName?.split(' ')
  const initials = nameParts?.length > 1
    ? `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`
    : nameParts?.[0][0]

  return (
    <div
      id={id}
      className={classNames({
        [classes.avatar]: true,
        [classes[size]]: true,
        [classes.incomplete]: isIncomplete
      })}
    >
      {initials ? initials : <FontAwesomeIcon icon={faUser} />}
    </div>
  )
}
